import update from 'immutability-helper'
import {
  // PLOP_APPEND_PATTERN_ANCHOR_ACTIONS_IMPORT
  GET_CUSTOM_CONVERSIONS,
  GET_CUSTOM_CONVERSIONS_SUCCESS,
  GET_CUSTOM_CONVERSIONS_FAILURE,
  CLEAR_GET_CUSTOM_CONVERSIONS,
  GET_CHOICES_BEHAVIOURS,
  GET_CHOICES_BEHAVIOURS_SUCCESS,
  GET_CHOICES_BEHAVIOURS_FAILURE,
  CLEAR_GET_CHOICES_BEHAVIOURS,
  GET_FACEBOOK_CLIENT_APPS,
  GET_FACEBOOK_CLIENT_APPS_SUCCESS,
  GET_FACEBOOK_CLIENT_APPS_FAILURE,
  CLEAR_GET_FACEBOOK_CLIENT_APPS,
  GET_CHOICES_GEOLOCATIONS,
  GET_CHOICES_GEOLOCATIONS_SUCCESS,
  GET_CHOICES_GEOLOCATIONS_FAILURE,
  CLEAR_CHOICES_GEOLOCATIONS,
  GET_CHOICES_COUNTRIES,
  GET_CHOICES_COUNTRIES_SUCCESS,
  GET_CHOICES_COUNTRIES_FAILURE,
  GET_CHOICES_INTERESTS,
  GET_CHOICES_INTERESTS_FAILURE,
  GET_CHOICES_INTERESTS_SUCCESS,
  GET_CHOICES_LANGUAGES,
  GET_CHOICES_LANGUAGES_SUCCESS,
  GET_CHOICES_LANGUAGES_FAILURE,
  GET_CHOICES_PIXELS,
  GET_CHOICES_PIXELS_SUCCESS,
  GET_CHOICES_PIXELS_FAILURE,
  CLEAR_CHOICES_PIXELS,
  GET_CHOICES_ACTIONS,
  GET_CHOICES_ACTIONS_SUCCESS,
  GET_CHOICES_ACTIONS_FAILURE,
  GET_CHOICES_CTA,
  GET_CHOICES_CTA_SUCCESS,
  GET_CHOICES_CTA_FAILURE,
  CLEAR_CHOICES_CTA,
  GET_CHOICES_ALLOCATION_UNITS,
  GET_CHOICES_ALLOCATION_UNITS_SUCCESS,
  GET_CHOICES_ALLOCATION_UNITS_FAILURE,
  CLEAR_CHOICES_INTERESTS,
  GET_CHOICES_CTA_BY_GOAL,
  GET_CHOICES_CTA_BY_GOAL_SUCCESS,
  GET_CHOICES_CTA_BY_GOAL_FAILURE,
  CLEAR_CHOICES_CTA_BY_GOAL
} from '../actions/choices'
import { INITIAL_GET_RESULTS_PAGING_REDUCER, INITIAL_GET_RESULTS_REDUCER } from '../../constants/reducer'

const initialState = {
  // PLOP_APPEND_PATTERN_ANCHOR_INITIAL_REDUCER
  geolocations: {
    items: [],
    isLoading: false
  },
  countries: INITIAL_GET_RESULTS_REDUCER,
  interests: {
    items: [],
    isLoading: false
  },
  languages: INITIAL_GET_RESULTS_REDUCER,
  pixels: INITIAL_GET_RESULTS_REDUCER,
  cta: INITIAL_GET_RESULTS_REDUCER,
  ctaByGoal: {},
  actions: INITIAL_GET_RESULTS_REDUCER,
  allocationUnits: INITIAL_GET_RESULTS_REDUCER,
  facebookClientApps: INITIAL_GET_RESULTS_PAGING_REDUCER,
  choicesBehaviours: INITIAL_GET_RESULTS_REDUCER,
  customConversions: INITIAL_GET_RESULTS_REDUCER
}

export default function choices(state = initialState, action) {
  switch (action.type) {
    // PLOP_APPEND_PATTERN_ANCHOR_REDUCERS
    case GET_CHOICES_GEOLOCATIONS:
      return update(state, {
        geolocations: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_CHOICES_GEOLOCATIONS_SUCCESS:
      return update(state, {
        geolocations: {
          $set: {
            isLoading: false,
            items: action.choicesData
          }
        }
      })
    case GET_CHOICES_GEOLOCATIONS_FAILURE:
      return update(state, {
        geolocations: {
          $set: initialState.geolocations
        }
      })
    case CLEAR_CHOICES_GEOLOCATIONS:
      return update(state, {
        geolocations: {
          $set: initialState.geolocations
        }
      })

    case GET_CHOICES_COUNTRIES:
      return update(state, {
        countries: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_CHOICES_COUNTRIES_SUCCESS:
      return update(state, {
        countries: {
          $merge: {
            isLoading: false,
            results: action.choicesData,
            wasLoaded: true
          }
        }
      })
    case GET_CHOICES_COUNTRIES_FAILURE:
      return update(state, {
        countries: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case GET_CHOICES_INTERESTS:
      return update(state, {
        interests: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_CHOICES_INTERESTS_SUCCESS:
      return update(state, {
        interests: {
          $set: {
            isLoading: false,
            items: action.choicesData
          }
        }
      })
    case GET_CHOICES_INTERESTS_FAILURE:
      return update(state, {
        interests: {
          $set: initialState.interests
        }
      })
    case CLEAR_CHOICES_INTERESTS:
      return update(state, {
        interests: {
          $set: initialState.interests
        }
      })

    case GET_CHOICES_LANGUAGES:
      return update(state, {
        languages: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_CHOICES_LANGUAGES_SUCCESS:
      return update(state, {
        languages: {
          $merge: {
            isLoading: false,
            results: action.choicesData,
            wasLoaded: true
          }
        }
      })
    case GET_CHOICES_LANGUAGES_FAILURE:
      return update(state, {
        languages: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case GET_CHOICES_PIXELS:
      return update(state, {
        pixels: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_CHOICES_PIXELS_SUCCESS:
      return update(state, {
        pixels: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.choicesData
          }
        }
      })
    case GET_CHOICES_PIXELS_FAILURE:
      return update(state, {
        pixels: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_CHOICES_PIXELS:
      return update(state, {
        pixels: {
          $set: initialState.pixels
        }
      })
    case GET_CHOICES_CTA:
      return update(state, {
        cta: {
          $merge: {
            isLoading: true
          }
        }
      })

    case GET_CHOICES_CTA_SUCCESS:
      return update(state, {
        cta: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.choicesData.results
          }
        }
      })
    case GET_CHOICES_CTA_FAILURE:
      return update(state, {
        cta: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })

    case CLEAR_CHOICES_CTA:
      return update(state, {
        cta: {
          $set: initialState.cta
        }
      })

    case GET_CHOICES_CTA_BY_GOAL:
      return update(state, {
        ctaByGoal: {
          $merge: {
            [action.params.goals]: {
              isLoading: true
            }
          }
        }
      })

    case GET_CHOICES_CTA_BY_GOAL_SUCCESS:
      return update(state, {
        ctaByGoal: {
          $merge: {
            [action.goal]: {
              isLoading: false,
              wasLoaded: true,
              results: action.choicesData.results
            }
          }
        }
      })
    case GET_CHOICES_CTA_BY_GOAL_FAILURE:
      return update(state, {
        ctaByGoal: {
          $merge: {
            [action.goal]: {
              isLoading: false,
              error: action.error
            }
          }
        }
      })

    case CLEAR_CHOICES_CTA_BY_GOAL:
      return update(state, {
        ctaByGoal: {
          $merge: {
            [action.goal]: undefined
          }
        }
      })

    case GET_CHOICES_ACTIONS:
      return update(state, {
        actions: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_CHOICES_ACTIONS_SUCCESS:
      return update(state, {
        actions: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.choicesData.results
          }
        }
      })
    case GET_CHOICES_ACTIONS_FAILURE:
      return update(state, {
        actions: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case GET_CHOICES_ALLOCATION_UNITS:
      return update(state, {
        allocationUnits: {
          $merge: {
            isLoading: true
          }
        }
      })
    case GET_CHOICES_ALLOCATION_UNITS_SUCCESS:
      return update(state, {
        allocationUnits: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.choicesData.results
          }
        }
      })
    case GET_CHOICES_ALLOCATION_UNITS_FAILURE:
      return update(state, {
        allocationUnits: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    // Get facebook client apps
    case GET_FACEBOOK_CLIENT_APPS:
      return update(state, {
        facebookClientApps: { $merge: { isLoading: true } }
      })
    case GET_FACEBOOK_CLIENT_APPS_SUCCESS:
      return update(state, {
        facebookClientApps: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data?.data,
            paging: {
              cursors: {
                before: action.data.paging?.cursors?.before,
                after: action.data.paging?.cursors?.after
              },
              previous: action.data.paging?.previous,
              next: action.data.paging?.next
            }
          }
        }
      })
    case GET_FACEBOOK_CLIENT_APPS_FAILURE:
      return update(state, {
        facebookClientApps: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_FACEBOOK_CLIENT_APPS:
      return update(state, {
        facebookClientApps: { $set: initialState.facebookClientApps }
      })

    // Get choices behaviours
    case GET_CHOICES_BEHAVIOURS:
      return update(state, {
        choicesBehaviours: { $merge: { isLoading: true } }
      })
    case GET_CHOICES_BEHAVIOURS_SUCCESS:
      return update(state, {
        choicesBehaviours: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_CHOICES_BEHAVIOURS_FAILURE:
      return update(state, {
        choicesBehaviours: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_CHOICES_BEHAVIOURS:
      return update(state, {
        choicesBehaviours: { $set: initialState.choicesBehaviours }
      })

    // Get custom conversions
    case GET_CUSTOM_CONVERSIONS:
      return update(state, {
        customConversions: { $merge: { isLoading: true } }
      })
    case GET_CUSTOM_CONVERSIONS_SUCCESS:
      return update(state, {
        customConversions: {
          $merge: {
            isLoading: false,
            wasLoaded: true,
            results: action.data
          }
        }
      })
    case GET_CUSTOM_CONVERSIONS_FAILURE:
      return update(state, {
        customConversions: {
          $merge: {
            isLoading: false,
            error: action.error
          }
        }
      })
    case CLEAR_GET_CUSTOM_CONVERSIONS:
      return update(state, {
        customConversions: { $set: initialState.customConversions }
      })
    default:
      return state
  }
}
